import { AuthProvider } from './components/auth/AuthProvider';
import { GoogleMapsProvider } from './components/common/GoogleMapsProvider';
import { Layout } from './components/common/Layout';
import { GlobalToast } from './components/common/GlobalToast';
import './index.css';
import { useEffect } from 'react';
import { useAppStore } from './store/appStore';
import { useServiceWorkerUpdate } from './hooks/useServiceWorkerUpdate';
import { UpdateNotification } from './components/common/UpdateNotification';
import { useGlobalToast } from './components/common/GlobalToast';

function App() {
  const { setTheme } = useAppStore();
  const { showSuccess } = useGlobalToast();

  // Hook para detectar actualizaciones del Service Worker
  const {
    isUpdateAvailable,
    newVersion,
    isUpdating,
    applyUpdate,
    skipUpdate,
    error: swError
  } = useServiceWorkerUpdate({
    checkInterval: 60000, // Verificar cada 60 segundos
    enableAutoCheck: true,
    onUpdateFound: (version) => {
      console.log('🔔 Nueva versión disponible:', version);
      showSuccess('¡Nueva versión disponible!');
    },
    onUpdateInstalled: () => {
      console.log('✅ Actualización instalada');
    },
    onError: (error) => {
      console.error('❌ Error en Service Worker:', error);
    }
  });

  // Log de versión actual de la app
  useEffect(() => {
    const version = import.meta.env.VITE_APP_VERSION || 'dev';
    console.log('📱 Versión de la aplicación:', version);
    console.log('🔧 Modo:', import.meta.env.MODE);
  }, []);

  // Configurar tema
  useEffect(() => {
    const savedTheme = localStorage.getItem('theme') as 'light' | 'dark' | null;
    if (savedTheme) {
      setTheme(savedTheme);
    } else {
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      setTheme(prefersDark ? 'dark' : 'light');
    }
  }, [setTheme]);

  // Log de error del Service Worker
  useEffect(() => {
    if (swError) {
      console.warn('⚠️ Service Worker error:', swError);
    }
  }, [swError]);

  return (
    <AuthProvider>
      <GoogleMapsProvider>
        <Layout />
      
        {/* Notificación de actualización */}
        <UpdateNotification
          isVisible={isUpdateAvailable}
          newVersion={newVersion}
          isUpdating={isUpdating}
          onUpdate={applyUpdate}
          onDismiss={skipUpdate}
          autoUpdateDelay={0} // 0 = no auto-update, usuario decide
          position="top"
          showVersionInfo={false} // Cambiar a true para mostrar número de versión
        />
        
        <GlobalToast position="top-center" />
      </GoogleMapsProvider>
    </AuthProvider>
  );
}

export default App;